import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router)

const originalPush=Router.prototype.push
Router.prototype.push=function push(location){
  return originalPush.call(this,location).catch(err=>err)
}


export let staticRouter =  [
  {
    path: '/',
    name: 'index',
    component: resolve => require(['@/pages/home/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/convert_page',
    name: 'convert_page',
    component: resolve => require(['@/pages/company_info/convert_page.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/convert_page2',
    name: 'convert_page2',
    component: resolve => require(['@/pages/enterprise_container/convert_page.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/company_info',
    name: 'company_info',
    component: resolve => require(['@/pages/company_info/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/enterprise',
    name: 'enterprise',
    component: resolve => require(['@/pages/enterprise_container/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/job_info',
    name: 'job_info',
    component: resolve => require(['@/pages/job_info/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    component: resolve => require(['@/pages/cooperation/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/deliver',
    name: 'deliver',
    component: resolve => require(['@/pages/deliver/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/company_duty',
    name: 'company_duty',
    component: resolve => require(['@/pages/company_duty/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/pages/login/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/register',
    name: 'register',
    component: resolve => require(['@/pages/login/register.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
  {
    path: '/my_resume',
    name: 'my_resume',
    component: resolve => require(['@/pages/video/index.vue'], resolve),
    mate:{ title:"员工设置", icon: "el-icon-s-custom"},
  },
]



export default new Router({
  routes:staticRouter
})



// WEBPACK FOOTER //
// ./src/router/index.js